import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from 'antd';
import { ApplicationDefinitionConditionalEditStore } from '../../stores';
import './ConditionsActionsRenderer.less';
import { HasPermission } from '../../../authorization/components/HasPermission';
import { AppPermissions } from '../../../authorization/Permissions';

interface Props {
    store: ApplicationDefinitionConditionalEditStore;
}

const ConditionsActionsRenderer: React.FC<Props> = ({ store }) => {
    return (
        <HasPermission
            key="application-definition-conditional-export-permission"
            entityId={store.project?.id}
            permissionClaim={AppPermissions.CanEditIotaApplications}
        >
            <div className="conditions-actions-renderer">
                <Button type="primary" onClick={() => store.setCreateEditConditionDialogVisible(true)}>
                    New Condition
                </Button>
            </div>
        </HasPermission>
    );
};

export default observer(ConditionsActionsRenderer);
